import { ENV } from "@/utils/common";

const testData = [
  {
    subjectType:1,
    majorName: '数学',
    teacherIds: '181,180,179,178',
    seaSonCourse26: '3682',
    seaSonCourse27: '3714',
    recommendCourse26:['3684','3682','3681','3680'],
    recommendCourse27:['3684','3682','3681','3680']
  },
  {
    subjectType:2,
    majorName: '英语',
    teacherIds: '158,177,176,175,173',
    seaSonCourse26: '3713',
    seaSonCourse27: '3711',
    recommendCourse26:['3684','3682','3681','3680'],
    recommendCourse27:['3684','3682','3681','3680']
  },
  {
    subjectType:3,
    majorName: '政治',
    teacherIds: '174,172,171',
    seaSonCourse26: '3642',
    seaSonCourse27: '3651',
    recommendCourse26:['3684','3682','3681','3680'],
    recommendCourse27:['3684','3682','3681','3680']
  },
];
const prodData = [
  {
    subjectType:1,
    majorName: '数学',
    teacherIds: '59,60,6',
    seaSonCourse26: '5274',
    seaSonCourse27: '5346',
    recommendCourse26:['5270'],
    recommendCourse27:['1029','5344']
  },
  {
    subjectType:2,
    majorName: '英语',
    teacherIds: '84,116,1290',
    seaSonCourse26: '5344',
    seaSonCourse27: '5347',
    recommendCourse26:['5262'],
    recommendCourse27:['1029','5242']
  },
  {
    subjectType:3,
    majorName: '政治',
    teacherIds: '101,100,119,1303',
    seaSonCourse26: '5275',
    seaSonCourse27: '5348',
    recommendCourse26:['5264'],
    recommendCourse27:['1029','5249']
  },
];
export const commonData = (ENV === 'test' || ENV === 'local') ? prodData : prodData
const couponDataProd = ['7737757318511714304','7737716499145183232']
const couponDatatest = ['7764745551763089408','7765209167712894976']
const teacherDescTest = {
  59:['明星讲师','风趣幽默'],
  60:['刷题真题','化繁为简'],
  6:['找准薄弱','针对性辅导'],
  84:['全能授课','注重基础'],
  116:['多维解题法'],
  1290:['恋练有词'],
  101:['马原史纲','独创解法'],
  100:['思修','极简背诵'],
  119:['逻辑体系','点拨难点'],
  1303:['毛中特','钻研真题'],
}
const teacherDescProd = {
  59:['明星讲师','风趣幽默'],
  60:['刷题真题','化繁为简'],
  6:['找准薄弱','针对性辅导'],
  84:['全能授课','注重基础'],
  116:['多维解题法'],
  1290:['恋练有词'],
  101:['马原史纲','独创解法'],
  100:['思修','极简背诵'],
  119:['逻辑体系','点拨难点'],
  1303:['毛中特','钻研真题'],
}
export const couponData = (ENV === 'test' || ENV === 'local') ? couponDatatest : couponDataProd
export const teacherDesc = (ENV === 'test' || ENV === 'local') ? teacherDescTest : teacherDescProd
export const nickNameList = [
  "云清雾淡",
  "飛驒",
  "觅云书",
  "學繪沉默",
  "风殇灬逍遥",
  "待到花落尽",
  "可乐里洗澡的鱼",
  "寂寞是个谎言",
  "夜丶無眠",
  "不需蓝颜",
  "长得丑照样傲",
  "馥·幽兰",
  "↙墨道刺青",
  "陌上烟雨遥",
  "栀晚鸢乱",
  "倾一世繁华容颜",
  "川水往事",
  "日光倾城",
  "树与藤的纠缠",
  "无梦旅人",
  "光辉时刻",
  "冷月寒光",
  "杯中酒男人泪",
  "南城忆潇湘",
  "浮殇℡",
  "一倾风月一流年",
  "浅巷墨漓°",
  "带上草帽来防晒",
  "青柠香味",
  "麦咪和熊熊",
  "挽歌朽年",
  "狂灵在世",
  "笑看人世繁华",
  "逆风飞翔",
  "丈母娘发货啊",
  "树街猫",
  "冰雨_落花",
  "未若柳絮",
  "初吻給了香烟",
  "鱼忘七秒",
  "醉倒美人怀",
  "花若怜ヽ",
  "江南春失忆梦",
  "暮色年华",
  "顾北清歌寒",
  "千鸢锁画",
  "青城蔚海",
  "萌城旧路少年与猫",
  "孤风",
  "朝晖暮音",
  "素颜殁",
  "莯愮婳淺°",
  "夜舞灬倾城",
  "一身傲气王",
  "笑我愚钝",
  "你是我的软肋",
  "花开半夏锁琉璃",
  "獨自流浪",
  "灭世炙天",
  "人生本就如梦",
  "今天一定要早睡",
  "夏日星光曼妙",
  "撑伞走过",
  "倾述聆听",
  "荔枝味的吻",
  "帘卷笙声寂",
  "氧气萌主",
  "一曲一场叹",
  "念旧",
  "伊人独醉",
  "回眸最初",
  "蔓栀",
  "梦里不觉秋已深",
  "想吃糖糖",
  "執筆·抒情殇",
  "傲弑嗜翼",
  "残灬绝影",
  "孤屿囚心",
  "半生七九",
  "纯白的梦",
  "持伞猫",
  "沉睡的彼岸花",
  "等时重觅",
  "小乖买糖吃",
  "骑着蜗牛追火箭",
  "眉敛翠烟深",
  "落尽殇寒",
  "天空很蓝袄",
  "青青浅吟年华未央",
  "依恋冰雪",
  "恶魔召唤",
  "孤浪王者",
  "柳下洺烟",
  "静若繁花",
  "世间皆苦",
  "半缕微凉致青春"
];

export const serverDesced = [
  {
    id:1,
    name:'入学测试',
    icon:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/serve_icon_001.png',
    desc:'入学摸底测试报告对用户的备考能力进行了全面诊断，帮助用户精准定位薄弱环节。入学报告旨在引导用户科学规划学习路径，优先巩固基础，为后续备考打下扎实根基',
    img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/content_001.png',
    appBtnName:'前往体验',
    miniBtnName: '前往“启航教育”app体验',
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
    miniJumpType:1,
    appJumpType:1,
  },
  {
    id:2,
    name:'知识点定位',
    icon:'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/svipProduct/serve_icon_003.png',
    desc:'视频标注功能能够在视频播放器的进度条上看到关键的知识点。这一功能不仅可以帮助学生快速定位到视频中的特定内容，还能提高学习效率，使学习过程更加便捷高效。',
    img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/content_002.png',
    appBtnName:'前往体验',
    miniBtnName: '前往“启航教育”app体验',
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
    miniJumpType:1,
    appJumpType:1,
  },
  {
    id:3,
    name:'学习笔记',
    icon:'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/svipProduct/serve_icon_008.png',
    desc:'学习笔记功能让学生能够在视频学习时进行笔记的即时记录与标注，同时提供分类整理与归纳。除了实时记录外，还具备快捷查找和复习回顾方式等。通过此功能，学生可以更好地记录、整理、复习，提高学习效率和质量。',
    img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/content_003.png',
    appBtnName:'前往体验',
    miniBtnName: '前往“启航教育”app体验',
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
    miniJumpType:1,
    appJumpType:1,
  },
  {
    id:4,
    name:'重点标记',
    icon:'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/svipProduct/serve_icon_010.png',
    desc:'视频标注功能能够在视频播放器进度条上看到关键知识点，快速定位视频中特定内容，提高学习效率',
    img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/content_004.png',
    appBtnName:'前往体验',
    miniBtnName: '前往“启航教育”app体验',
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
    miniJumpType:1,
    appJumpType:1,
  },
  {
    id:5,
    name:'学习报告',
    icon:'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/svipProduct/serve_icon_007.png',
    desc:'学习报告功能能够实时追踪用户的学习进度。通过记录用户观看视频的时间、频次、进度等信息，该功能可以生成详细的学习进度报告。过该功能，可以更加全面、客观地了解自己的学习情况，制定更加科学的学习计划。',
    img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/content_005.png',
    appBtnName:'前往“启航教育”app体验',
    miniBtnName: '前往体验',
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
    miniJumpType:2,
    appJumpType:1,
  },
  {
    id:6,
    name:'高频测试',
    icon:'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/svipProduct/serve_icon_004.png',
    desc:'同步测试覆盖了课前预习和课后训练。课前预习环节，通过总结课程的核心内容，突出重难点，帮助学生建立起对即将学习内容的基本认知。同时，课后训练环节，通过反复练习和回顾，学生可以更好地掌握知识点，形成扎实的学习基础。',
    img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/content_006.png',
    appBtnName:'前往体验',
    miniBtnName: '前往“启航教育”app体验',
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
    miniJumpType:1,
    appJumpType:1,
  },
  {
    id:7,
    name:'学情分析',
    icon:'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/svipProduct/serve_icon_006.png',
    desc:'针对用户在特定知识点上的薄弱环节进行了详细评估，提供了个性化提升建议，包括推送针对性练习、视频讲解，并支持深度挖掘和高效建模等学习功能，帮助用户高效补足短板。报告还包含一键推送服务，方便用户快速获取定制化学习资源，提升综合能力。',
    img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/content_007.png',
    appBtnName:'前往体验',
    miniBtnName: '前往“启航教育”app体验',
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
    miniJumpType:1,
    appJumpType:1,
  },
  {
    id:8,
    name:'AI答疑',
    icon:'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/svipProduct/serve_icon_011.png',
    desc:'AI黑科技助力全学科备考单图/多图/文字提问 三秒击破学习疑问（支持高数公式识别/英语长难句语法拆解/专业课术语库等)',
    img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/content_008.png',
    appBtnName:'前往“启航考研”小程序体验',
    miniBtnName: '前往体验',
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
    miniJumpType:4,
    appJumpType:3,
    miniPath: '/aiAnswer/answerHome/index'
  },
  {
    id:9,
    name:'AI作文批改',
    icon:'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/svipProduct/serve_icon_012.png',
    desc:'通过逐词批改和精准诊断，为用户提供了详细的评分与反馈。报告涵盖多个维度的评估，包括评级、多语对比、全文对照和美句分析，帮助用户明确薄弱环节，为后续的针对性提升提供科学依据。',
    img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/content_009.png',
    appBtnName:'前往“启航考研”小程序体验',
    miniBtnName: '前往体验',
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
    miniJumpType:4,
    appJumpType:3,
    miniPath: '/correction/home/index'
  },
]
export const serverDescWait = [
  {
    id:10,
    name:'1v1答疑',
    icon:'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/svipProduct/serve_icon_002.png',
    desc:'精准解答知识点疑惑，指导解题技巧，提升应试能力。APP专区提供7*24小时不间断答疑服务，工作日12小时内回复（法定节假日除外）。提供专业问题解答，个性化服务体验，让答疑更高效',
    img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/content_010.gif',
    appBtnName:'前往体验',
    miniBtnName: '前往体验',
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
    miniJumpType:3,
    showImg:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/show-answer.gif',
    appJumpType:2,
  },
  {
    id:11,
    name:'1v1批改',
    icon:'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/svipProduct/serve_icon_005.png',
    desc:'专业老师人工批改，手把手纠细节，精准提分。提供个性化指导，针对具体情况给出针对性的反馈和指导，帮助更好地理解和掌握知识，提高学习效果。',
    img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/content_011.gif',
    appBtnName:'前往体验',
    miniBtnName: '前往体验',
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
    miniJumpType:3,
    showImg:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/show-check.gif',
    appJumpType:2,
  },
  {
    id:12,
    name:'1v1学情诊断',
    icon:'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/svipProduct/serve_icon_009.png',
    desc:'通过专业教师1V1电话沟通（30分钟内）为学员提供精准学情评估。服务流程包括：基于学员学习/测试数据的专业分析、针对性电话沟通诊断，最终形成包含具体复习建议的书面诊断报告。该服务特别适合需要深度了解自身学习状况、获取专业指导建议的学生，帮助其快速定位问题并制定高效提升方案。',
    img:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/content_012.png',
    appBtnName:'',
    miniBtnName: '',
    h5BtnName: '',
    h5JumpType: 1,
    miniJumpType:'',
    appJumpType:'',
  },
]

export const ourseIntroduction = [
  {
    id:1,
    name: '1V1导学',
    desc: ['报名后24h内电话导学','入学测试，诊断学情','个性化学习建议'],
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/1v1daoxue.png',
    icon:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/courseContent_icon_003.png',
  },
  {
    id:2,
    name: '1v1督学',
    desc: ['每月规划学习任务，任务细化到每天','1v1每周督学提醒(学习进度跟进、学情指导、动态调整)','30人学习班级群（日常课程更新同步、考研时间节点信息、备考资料互助分享）'],
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/1v1duxue.png',
    icon:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/courseContent_icon_004.png',
  },
  {
    id:3,
    name: '1v1答疑',
    desc: ['N（师）V1（生）微信答疑','APP答疑专区1v1答疑','月度答疑直播'],
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/1v1dayi.png',
    icon:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/courseContent_icon_002.png',
  },
  {
    id:4,
    name: '1v1学情',
    desc: ['专业老师1v1电话沟通学习问题'],
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/1v1xueqing.png',
    icon:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/courseContent_icon_007.png',
  },
  {
    id:5,
    name: '1v1辅导授课',
    desc: ['10课时教研老师1V1辅导，解决个性化学习问题'],
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/1v1fudaoshouke.png',
    icon:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/courseContent_icon_001.png',
  },
  {
    id:7,
    name: '学员反馈',
    desc: [],
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/fankui.png',
    icon:'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/courseContent_icon_005.png',
  }
]

export const courseIntroductionSubject = {
  1: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/1V1pigai-shuxue.png',
  2: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/1V1pigai-zhengzhi.png',
  3: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/1V1pigai-yingyu.png'
}


